
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'
import style, { tHeadRowHeight, tBodyRowHeight } from './style'
import { VerbalColorType } from '../../../types'

const useStyles = makeStyles(style)

type TDType = {
    text: string
} & React.ComponentProps<'td'>

/**
 *
 */
export type TableType = {
    columns: string[] | TDType[],
    rows: React.ReactNode[][] | TDType[], // [['row1', 'row2]] || [[{colspan=4, text: 'row1}]] || <Typohraphy variant='h1'>Test</Typography>
    footerRows?: React.ReactNode[][] | TDType[]
    color?: VerbalColorType
    scrollAfterRow?: number
    className?: string
    'data-testid'?: string
}

/**
 *
 */
const Table = ({
    columns,
    rows,
    footerRows,
    color = 'neutral-50',
    scrollAfterRow,
    className = '',
    'data-testid': dataTestId = 'table'
}: TableType) => {
    const classes = useStyles({ color })

    const columnWidthNotHavingHeading = 4
    const columnsHavingHeading = columns.filter(column => Boolean(column)).length
    const columnsNotHavingHeading = columns.length - columnsHavingHeading
    const columnWidthHavingHeading = (100 - (columnsNotHavingHeading * columnWidthNotHavingHeading)) / columnsHavingHeading
    const hasColspan = columns && columns.some((x) => typeof x === 'object' && Object.prototype.hasOwnProperty.call(x, 'colSpan'))
    const shouldScroll = Boolean(scrollAfterRow && scrollAfterRow > 0 && rows.length > scrollAfterRow)
    const tableContainerStyle =
        shouldScroll
            ? {
                maxHeight: `${tHeadRowHeight + (scrollAfterRow * tBodyRowHeight)}px`,
                overflowY: 'auto'
            }
            : undefined

    return (
        <div className={`${classes.tableContainer} table-container`} style={tableContainerStyle} data-testid='table-container'>
            <table className={`${classes.table} ${className}`} data-testid={dataTestId}>
                {columns &&
                    <thead className={classes.tHead} data-testid={`${dataTestId}-columns`}>
                        <tr>
                            {
                                columns.map((column, index) => {
                                    const columnHavingHeading = Boolean(column)

                                    return (
                                        <th
                                            key={index}
                                            style={{
                                                width: `${!column?.colSpan && columnHavingHeading ? columnWidthHavingHeading : columnWidthNotHavingHeading}%`,
                                                ...column?.style
                                            }}
                                            colSpan={column?.colSpan}
                                            data-testid={`${dataTestId}-column-${index}`}
                                        >
                                            <Typography variant='body3'>{typeof column === 'string' ? column : column.text}</Typography>
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                }
                {
                    rows &&
                    <tbody className={classes.tBody}>
                        {rows.map((thisRow, rIndex) => (
                            <tr key={rIndex} data-testid={`${dataTestId}-row-${rIndex}`}>
                                {thisRow.map((data, dIndex) => <td key={dIndex}>
                                    <Typography variant='subtitle2' data-testid={`${dataTestId}-row-${rIndex}-${dIndex}`}>
                                        {data}
                                    </Typography>
                                </td>)}
                            </tr>
                        ))}
                    </tbody>
                }
                {
                    footerRows &&
                    <tbody className={classes.tFoot}>
                        {footerRows.map((thisRow, index) => (
                            <tr key={index}>
                                {thisRow.map((data, index) => <td key={index}><Typography variant='body3'>{data}</Typography></td>)}
                            </tr>
                        ))}
                    </tbody>
                }
            </table>
        </div>
    )
}

export default Table
